/**
 * AlmadarPostDigitalSovereigntyAlmadarProposalENAlmadarPostDigitalSovereigntyAlmadarProposalENPage
 *
 * Page component for AlmadarPostDigitalSovereigntyAlmadarProposalENAlmadarPostDigitalSovereigntyAlmadarProposalENPage
 * Path: /blog/digital-sovereignty-almadar-proposal
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageView as __AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageView';
import { AlmadarPostDigitalSovereigntyAlmadarProposalENPostAnalyticsView as __AlmadarPostDigitalSovereigntyAlmadarProposalENPostAnalyticsView } from '@/components/traits/AlmadarPostDigitalSovereigntyAlmadarProposalENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostDigitalSovereigntyAlmadarProposalENAlmadarPostDigitalSovereigntyAlmadarProposalENPageProps {
  // Add any page-level props here
}

export function AlmadarPostDigitalSovereigntyAlmadarProposalENAlmadarPostDigitalSovereigntyAlmadarProposalENPage(_props: AlmadarPostDigitalSovereigntyAlmadarProposalENAlmadarPostDigitalSovereigntyAlmadarProposalENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostDigitalSovereigntyAlmadarProposalENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostDigitalSovereigntyAlmadarProposalENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostDigitalSovereigntyAlmadarProposalENAlmadarPostDigitalSovereigntyAlmadarProposalENPage;
